export const ACCOUNT_MANAGER_USERNAMES = ['jj', 'jckim'];

export function isAccountManager(user) {
  const username = String(user?.username || user?.email?.split('@')?.[0] || '').trim().toLowerCase();
  return String(user?.role || '').toLowerCase() === 'admin' && ACCOUNT_MANAGER_USERNAMES.includes(username);
}
